import { render, staticRenderFns } from "./VotingBoard.vue?vue&type=template&id=0b5bd2a7"
import script from "./VotingBoard.vue?vue&type=script&lang=js"
export * from "./VotingBoard.vue?vue&type=script&lang=js"
import style0 from "./VotingBoard.vue?vue&type=style&index=0&id=0b5bd2a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports